<header-title [model]="headerTitle"></header-title>

<section class="panel">
    <div class="row mb-3">
        <div class="col col-md-6">
            <button class="btn btn-primary" type="button" [routerLink]="['/company/add']">Add New Company</button>
        </div>
        <div class="col col-md-6">
            <div class="row" style="align-items:flex-end;">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none dark">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th class="text-center">Type</th>
                        <th class="text-center">Users</th>
                        <th class="text-center">Active</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let company of companyList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{company.legalName}}</td>
                        <td class="text-center">{{company.companyTypeDescription}}</td>
                        <td class="text-center">{{company.usersAssigned}}</td>
                        <td class="text-center">
                            <span class="fas fa-check" *ngIf="company.isActive"></span>
                            <span class="fas fa-times text-danger" *ngIf="!company.isActive"></span>
                        </td>
                        <td class="actions text-center">
                            <a [routerLink]="['/company', company.id]" class="pl-3 pr-3 mb-1 mt-1 me-2 btn-link" title="Edit"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
